// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"6b80d534","787":"c15c2e07","891":"d7e61531"}[chunkId] + ".chunk.js";
};